







































import Vue from 'vue';
import { validateEmail, trimBrackets } from '@/utils';
export default Vue.extend({
  props: {
    email: String,
    roleName: {
      type: String,
      default: 'member'
    },
    showKeyboardShortcut: Boolean
  },

  computed: {
    article(): string {
      return /^[aeiou]/i.test(this.roleName) ? 'an' : 'a';
    },

    isValidEmail(): boolean {
      return validateEmail(this.parsedEmail);
    },

    parsedEmail(): string {
      return trimBrackets(this.email.trim());
    },

    showParsed(): boolean {
      return this.email !== this.parsedEmail;
    }
  },

  methods: {
    onCreate() {
      this.$emit('create-user', this.parsedEmail);
    },

    update(value: string) {
      this.$emit('update', value);
    }
  }
});
